import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const MobileStickyCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > window.innerHeight * 0.6);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-[var(--primary)] bg-[var(--background)] shadow-[0_-4px_20px_rgba(0,0,0,0.2)]">
      <Link
        to="/services/quarterly-trainings/register"
        className="flex items-center justify-center gap-2 bg-[var(--primary)] text-black font-mono font-bold text-sm py-3 uppercase tracking-widest"
      >
        Reserve Your Seat
        <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
};

export default MobileStickyCTA;
